import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-group mb-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to cancel your subscription?")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_kendo_modal = _resolveComponent("kendo-modal")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, { onSubmit: _ctx.onSubmit }, {
      default: _withCtx(({ isSubmitting }) => [
        _createVNode(_component_kendo_modal, {
          modelValue: _ctx.showModal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showModal) = $event)),
          title: "Cancel Subscription",
          "gap-buttons": true,
          submitting: isSubmitting,
          "save-button-text": "Cancel My Subscription",
          "save-button-icon": "",
          "cancel-button-text": "Keep My Subscription",
          "is-cancel-pop-up": true,
          onModalCancel: _ctx.onModalCancel,
          onModalSave: _ctx.onModalConfirm,
          onModalHide: _ctx.onModalClose
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 2
        }, 1032, ["modelValue", "submitting", "onModalCancel", "onModalSave", "onModalHide"])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ]))
}